module.exports = __webpack_public_path__ + "img/fudan_logo.5222c633.png";